var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 35,
    viewBox: "0 0 40 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M27.6487 32.543L16.372 34.2092L0.717285 28.8013L16.8082 20.1353L27.6487 32.543Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5412 12.9756V23.9037L27.6484 32.5428V17.3154L39.5412 12.9756Z",
    fill: "#FBB91E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9126 12.9756L15.3331 25.0056L27.6486 32.5428V16.9556L14.9126 12.9756Z",
    fill: "#EDA32C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9126 10.3022V12.9758L27.6486 20.1353V15.5415L14.9126 10.3022Z",
    fill: "#FBB91E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5412 10.3022V12.9758L27.6484 20.1353V15.5415L39.5412 10.3022Z",
    fill: "#F8D841"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9126 10.3019L27.5947 17.3153L39.5414 10.3019L27.2281 3.31104L14.9126 10.3019Z",
    fill: "#FFDD17"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1646 27.344L21.2805 28.6392V13.9941L19.1646 12.9688V27.344Z",
    fill: "#B465FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7979 14.2619V28.8013L34.635 27.4679V13.1826L32.7979 14.2619Z",
    fill: "#B465FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1646 12.9755L27.228 8.46484L34.6349 13.1824L32.7978 14.2617L27.228 10.8528L21.2805 14.0009L19.1646 12.9755Z",
    fill: "#C58CFB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2282 9.47438C27.2282 9.47438 27.109 9.24953 26.8999 8.88975C25.9308 7.19881 23.0076 2.47452 21.2807 3.31324C21.2807 3.31324 19.9653 5.06714 20.2216 5.52586C20.4779 5.98457 25.7172 10.3963 26.2681 10.3041C26.819 10.2119 27.109 9.25402 27.109 9.25402",
    fill: "#B465FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2216 5.52393C20.2216 5.52393 26.5446 9.75128 26.2681 10.3022C25.9915 10.8531 20.0575 7.45322 20.2216 5.52393Z",
    fill: "#923EE9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2769 8.99557C26.2769 8.99557 27.1763 0.84667 30.4053 0.151855C30.4053 0.151855 32.3346 0.995077 32.2424 1.88102C32.1502 2.76697 28.5929 10.5808 27.6462 10.302C26.6996 10.0232 26.2769 8.99557 26.2769 8.99557Z",
    fill: "#B465FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5661 10.3625C28.5661 10.3625 32.0987 6.09022 32.2426 1.88086C32.2426 1.88086 25.4428 10.3288 28.5661 10.3625Z",
    fill: "#923EE9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6465 9.15984C27.6465 9.15984 27.8713 9.04066 28.2446 8.85628C29.9963 7.99057 35.0489 5.67902 36.0157 7.32949C36.0157 7.32949 36.1372 9.51736 35.6695 9.75796C35.2018 9.99856 28.4043 10.7698 27.986 10.3876C27.5678 10.0053 27.8713 9.03841 27.8713 9.03841",
    fill: "#B465FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6694 9.7666C35.6694 9.7666 28.0624 9.7666 27.986 10.3872C27.9095 11.0078 34.7363 11.462 35.6694 9.7666Z",
    fill: "#923EE9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.e7b744e94adc37d6103957b4b4079734.svg";
export { ForwardRef as ReactComponent };